import React from 'react';
export function ProjectGallery() {
  return <section id="projects" className="bg-[#fbfaf6] py-20 sm:py-28" data-id="element-79">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-80">
        <div className="flex flex-col justify-between gap-5 sm:flex-row sm:items-end" data-id="element-81">
          <div data-id="element-82">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#356d70]" data-id="element-83">
              Made for the desert
            </p>
            <h2 className="mt-5 text-4xl font-medium tracking-[-0.045em] text-[#173d36] sm:text-5xl" data-id="element-84">
              Water with a sense of place.
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-6 text-[#5d675f]" data-id="element-85">
            A backyard pool is not just an amenity. It is a place to reset,
            host, stretch out, and return to.
          </p>
        </div>
        <div className="mt-12 grid gap-4 md:grid-cols-2" data-id="element-86">
          <figure className="md:row-span-2" data-id="element-87">
            <img className="h-[460px] w-full rounded-[1.5rem] object-cover md:h-full" src="https://cdn.magicpatterns.com/uploads/h3ssF9HaTEPGQgVTXseVX8/Screenshot_2026-07-10_102212.png" alt="Natural pool and spa with a rock waterfall feature" data-id="element-88" />
            <figcaption className="mt-3 text-sm text-[#5d675f]" data-id="element-89">
              Water features and a natural setting, designed for lingering
              outside.
            </figcaption>
          </figure>
          <figure data-id="element-90">
            <img className="h-64 w-full rounded-[1.5rem] object-cover" src="https://cdn.magicpatterns.com/uploads/vJw9uLGXsNPLCCR8wdp23W/Screenshot_2026-07-10_102325.png" alt="Backyard pool and raised spa with water features" data-id="element-91" />
          </figure>
          <figure data-id="element-92">
            <img className="h-64 w-full rounded-[1.5rem] object-cover" src="https://cdn.magicpatterns.com/uploads/iuBHco6Q95MvJszaFVFRpG/Screenshot_2026-07-10_102302.png" alt="Contemporary pool with a paved terrace and landscaped garden" data-id="element-93" />
          </figure>
        </div>
      </div>
    </section>;
}